const en = {
    //hirestep 01
  serviceCall : 'Service provider can call',
  heading_request : 'What are the details of your job request ?',
  valid_question1 : 'Any other details you see relevant ?',
  valid_question2:
      'If you do not provide enough information. this will affect the number of quotes you will receive.',
  valid_question3 : 'You should input 100 letters at least.',
  image_question : 'Would you like to add pictures ?',
  where_location : 'Where ? (Location of the job)',
  location_validation:
      'We can\'t use your location. Please search city or input manually',
  userMyLocation : 'USE MY LOCATION',
  enterCity : 'Enter your city name',
  when_job : 'When ? (date of the job)',
  answer_question : 'Would you like to answer these questions ?',
  inputAnswer : 'Input your answer here...',
  enterPhone : 'Enter your Phone',
  phoneDescription:
      'Our pros con contact you faster if you select “Service provider can call “.',
  enterPhoneNumber : 'Enter your phone number',
  sendRequest : 'SEND REQUEST',
  alert_image : 'Please upload at least one image.',
  alert_description : 'Please input description.',
  alert_address : 'Please input your address.',
  alert_one_option : 'Please select one option.',
  alert_pick_date : 'Please pick up date.',
  alert_answer : 'Please answer the question',
  alert_phone : 'Please input phone number.',
  request_success_msg:
      'Congratulation! You have requested successfully!',
  alert_close_description:
      'You can get free quotes by answering few more questions.',
  go_on : 'GO ON',
  quit : 'QUIT',
  servicesCompanyReady : "Services company ready",
  allow_contacts : "Show my phone number",
  dont_disturbme : "Don't disturb me",
  only_phone : "Contact me only by phone",
  only_offers : "Send me only offers",
  only_whatsapp : "Contact me only by whatsapp",

  
  //Password

  kEmailNullError: "Please Enter your email",
  kInvalidEmailError: "Please Enter Valid Email",
  kPassNullError: "Please Enter your password",
  kConfirmPasswordError: "Password mismatching",
  kShortPassError: "Password is too short, at least 8 chars",
  kMatchPassError: "Passwords don't match",
  kNameNullError: "Please Enter your full name",
  kPhoneNumberNullError: "Please Enter your phone number",

  //and

  email: 'Email',
  password: 'Password',
  pleaseendteryouremail: 'Please enter your email',
  pleaseenteryourpassword: 'Please enter your password',

  confirmpassword: 'Confirm password',

  name: 'Name',

  requestPriority: 'Request Priority',
  Congratulation: 'Congratulation',

  free: 'Free',
  high: 'High',

  inputThree: 'Please input at least 3 letters',
  noSearchResult: 'No Search Result ',

  selected_city: 'Selected  City(s)',

  //

  specificTime: 'Specific Time (Within three weeks)',
  inTwoMonth: 'In Two Months',
  inSixMonth: 'In Six Months',
  onlyPrice: 'Just looking for price',
  flexibleTime: 'Flexible',
  asap: 'As soon as possible',

  lab_continue: 'Continue',



  //CUSTOM
  mainheading: 'What type of services are you looking for? ',
  back: 'Back',
  serviceErrHead: 'Empty service',
  serviceError: 'Please select a service you are looking for to continue.',

  requiredField: "Required field",
  requireDesc: 'This field is mandatory.'
}

export default en;